import * as actions from './actionConstants';

export const sendMessage = (message,recipients) => ({
  type: actions.SEND_MESSAGE,
  message,
  recipients
});

export const sendMessageSuccess = () => ({
  type: actions.GET_TODAYS_WEATHER_SUCCESS
});

export const sendMessageError = error => ({
  type: actions.GET_TODAYS_WEATHER_ERROR,
  error
});


// WEBPACK FOOTER //
// ./src/actions/smsActions.js